import { render, staticRenderFns } from "./DeleteDnsRecordDialog.vue?vue&type=template&id=1f3a6e71&"
import script from "./DeleteDnsRecordDialog.vue?vue&type=script&lang=ts&"
export * from "./DeleteDnsRecordDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports